var map = {
	"./BuddhaAkshay/images/LoginBackgroundImage.png": [
		8639,
		639
	],
	"./JanBhavishya/images/LoginBackgroundImage.png": [
		33556,
		556
	],
	"./Suvarna/images/LoginBackgroundImage.png": [
		63600,
		600
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 37583;
module.exports = webpackAsyncContext;